import React from 'react';
import AdvertListItem from './components/AdvertListItem';
import Loader from '../UI/Loader/Loader';
import styles from './AdvertList.module.scss';
import helpers from '../../helpers/helpers';

const AdvertList = ({ products, isLoading, onDeleteItem }) => {
  const { getTranslationText } = helpers;

  return (
    <div className={styles.adverts}>
      {
        !isLoading && !products?.length && <p className={styles.advertsEmpty}>
          {getTranslationText('general.no_products') || 'There are no products here yet'}
        </p>
      }
      <div className={styles.advertsGrid}>
        {
          products && products.map((product) => (
            <AdvertListItem
              product={product}
              key={product.id}
              onDelete={onDeleteItem}
            />
          ))
        }
      </div>
      {
        isLoading && <Loader stickyCircle />
      }
    </div>
  );
};

export default AdvertList;
